import type { CSSProperties } from "react";
import { clamp } from "../lib/format";

export function ProgressRing({ value, label }: { value: number; label: string }) {
  const safeValue = clamp(value, 0, 100);
  return (
    <div
      className="progress-ring"
      style={{ "--progress": `${safeValue * 3.6}deg` } as CSSProperties}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Number(safeValue.toFixed(1))}
    >
      <div className="progress-ring__inner">
        <strong>{safeValue.toFixed(1)}%</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}
